// export const API = import.meta.env.VITE_API_URL;

// export const API = 'https://api.haltap.com/api';
export const API = 'https://www.api.haltap.com/api'
